import React from "react";
import PropTypes from "prop-types";
import {Grid} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import {mobileLogoOffset} from "../resources/environment";

const usePageHeaderRowStyles = makeStyles()((theme) => ({
  row: {
    [theme.breakpoints.down("sm")]: {
      marginLeft: mobileLogoOffset,
    },
  },
}));

// Wraps a page's title row — back arrow, title, and actions, but not the tab bar
// below it — and indents it clear of the fixed logo button on xs views
const PageHeaderRow = ({children, className, ...gridProps}) => {
  const {classes, cx} = usePageHeaderRowStyles();

  return (
    <Grid container className={cx(classes.row, className)} {...gridProps}>
      {children}
    </Grid>
  );
};

PageHeaderRow.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default PageHeaderRow;
